import { useSelector } from '~/_shared/utils/hooks/useSelector';
import { createStateSelector } from '~/_shared/utils/memoize/createSelector';
import { type AppState } from '~/store/app.store';
import { selectIsUserOverDirectionsApiLimit } from '~/store/userData/userData.selectors';

const routesUiDataSelector = (state: AppState) => state.frontendState.mapTools.directions.routesUiData;
export const useRoutesUiDataSelector = () => useSelector(routesUiDataSelector);

const directionsExpandedRouteIdsSelector = (state: AppState) => state.frontendState.mapTools.directions.expandedRouteIds;
export const useDirectionsExpandedRouteIdsSelector = () => useSelector(directionsExpandedRouteIdsSelector);

const directionsScrollIntoViewpointsFormSelector = (state: AppState) => state.frontendState.mapTools.directions.scrollIntoViewpointsForm;
export const useDirectionsScrollIntoViewpointsFormSelector = () => useSelector(directionsScrollIntoViewpointsFormSelector);

const directionsLastLoadedRouteSelector = (state: AppState) => state.frontendState.mapTools.directions.lastLoadedRoute;
export const useDirectionsLastLoadedRouteSelector = () => useSelector(directionsLastLoadedRouteSelector);

const directionsShouldBeginAtUserLocationSelector = (state: AppState) => state.map.mapSettings.data.directions.shouldBeginAtUserLocation;
export const useDirectionsShouldBeginAtUserLocationSelector = () => useSelector(directionsShouldBeginAtUserLocationSelector);

const directionsCanDragRoutesStateSelector = (state: AppState) => state.map.mapSettings.data.directions.canDragRoutes;
const directionsCanDragRoutesSelector = createStateSelector([
  directionsCanDragRoutesStateSelector,
  selectIsUserOverDirectionsApiLimit,
], (canDrag, isOverLimit) => {
  return isOverLimit ? false : canDrag;
});
export const useDirectionsCanDragRoutesSelector = () => useSelector(directionsCanDragRoutesSelector);

const directionsSelectedCollapsingSelector = (state: AppState) => state.map.mapSettings.data.directions.selectedCollapsing;
export const useDirectionsSelectedCollapsingSelector = () => useSelector(directionsSelectedCollapsingSelector);
